module.exports = __webpack_public_path__ + "static/img/56.d9ca74c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/56.png
// module id = Ixiw
// module chunks = 0